import { Box, Divider as MuiDivider } from "@mui/material";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import WeatherForecast from "layout-components/Weather/WeatherForecast";
import { getWeather } from "../../modules/weather/api/actions";
import { getDisconnectMetrics } from "../../modules/accountDisconnects/api/actions";
import WeekView from "../../modules/disconnectSchedules/components/WeekView"
import DisconnectQueue from "./DisconnectQueue";
import {
    Typography,
} from "@mui/material";
import { WiTime10 } from "react-icons/wi";
import { startOfWeek, format } from "date-fns";
import StatCard from "../../components/cards/StatCard";
import {
    PowerOffOutlined,
    PauseCircleOutlined,
    ScheduleOutlined,
    AccountBalanceOutlined
} from "@mui/icons-material";
import { numberWithCommas, formatMoney } from "../../setup/helpers";

const Divider = styled(MuiDivider)(spacing);

const DisconnectCommandCenter = (props) => {

    useEffect(() => {
        props.getWeather("Columbus, OH");
        props.getDisconnectMetrics();
        document.title = "Disconnect Command Center";
    }, []);

    const metrics = props.accountDisconnects?.metrics?.data;
    const isLoadingMetrics = props.accountDisconnects?.metrics?.isLoading || false;

    return (
        <NavFrame page={"Disconnect Command Center"}>
            <Box sx={{ margin: '0 auto', width: '100%' }}>
                <StandardHeader
                    title="Disconnect Command Center"
                    appPath="Disconnect Command Center"
                />
                <Typography sx={{ color: 'gray' }}>Manage property disconnections and compliance holds</Typography>
                <Divider className="mb-3 mt-3" />
                <WeatherForecast weatherData={props.weather.data} isLoading={props.weather.isLoading} error={props.weather.error} />
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginY: 4 }}>
                    <Typography variant="h3" sx={{ fontWeight: 'bold' }}>Weekly Disconnect Schedule</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                        <WiTime10 size={20} />
                        <span>Week of {format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'MMMM d, yyyy')}</span>
                    </Box>
                </Box>
                <WeekView />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    gap: '10px',
                    marginTop: 0,
                    flexWrap: 'wrap'
                }}>
                    <StatCard
                        title="Total Disconnected"
                        value={metrics ? numberWithCommas(metrics.totalDisconnectedUnits) : '0'}
                        icon={<PowerOffOutlined sx={{ fontSize: '16px' }} />}
                        iconColor="green"
                        subtitle="Currently Disconnected"
                        isLoading={isLoadingMetrics}
                    />
                    <StatCard
                        title="Total Held"
                        value={metrics ? numberWithCommas(metrics.totalHeld) : '0'}
                        icon={<PauseCircleOutlined sx={{ fontSize: '16px' }} />}
                        iconColor="red"
                        subtitle="Holiday/Medical Holds"
                        isLoading={isLoadingMetrics}
                    />
                    <StatCard
                        title="Aged Disconnects"
                        value={metrics ? numberWithCommas(metrics.agedDisconnects) : '0'}
                        icon={<ScheduleOutlined sx={{ fontSize: '16px' }} />}
                        subtitle="Over 7 Days Old"
                        isLoading={isLoadingMetrics}
                    />
                    <StatCard
                        title="Total Outstanding Balance"
                        value={metrics ? formatMoney(metrics.totalOutstandingBalance) : '$0.00'}
                        icon={<AccountBalanceOutlined sx={{ fontSize: '16px' }} />}
                        iconColor="red"
                        subtitle="Total"
                        isLoading={isLoadingMetrics}
                    />
                </Box>
                <DisconnectQueue />
            </Box>
        </NavFrame>
    );
};

DisconnectCommandCenter.propTypes = {
    getWeather: PropTypes.func.isRequired,
    weather: PropTypes.object.isRequired,
    getDisconnectMetrics: PropTypes.func.isRequired,
    accountDisconnects: PropTypes.object.isRequired,
};

function DisconnectCommandCenterState(state) {
    return {
        weather: state.weather,
        accountDisconnects: state.accountDisconnects,
    };
}

export default connect(DisconnectCommandCenterState, {
    getWeather,
    getDisconnectMetrics,
})(DisconnectCommandCenter);
